<!-- src/components/Layout/ImpersonationBanner.vue -->
<template>
  <div
    v-if="userStore.isImpersonating"
    class="sticky top-0 z-[9999] border-b-2 border-yellow-500 bg-yellow-400 px-4 py-2 text-black shadow-lg"
  >
    <div class="mx-auto flex max-w-screen-2xl items-center justify-between text-sm">
      <div class="flex items-center">
        <AlertTriangle class="mr-3 h-5 w-5 text-yellow-900" />
        <p class="font-semibold">
          You are viewing as
          <span class="font-bold underline">{{ userStore.user.displayName }}</span
          >.
        </p>
      </div>
      <button
        @click="exitImpersonation"
        class="flex items-center gap-1.5 font-bold text-yellow-900 transition-colors hover:text-black hover:underline"
      >
        Exit Impersonation
        <LogOut class="h-4 w-4" />
      </button>
    </div>
  </div>
</template>

<script setup>
import { useUserStore } from '@/stores/userStore'
import { AlertTriangle, LogOut } from 'lucide-vue-next'
import { useToast } from '@/composables/useToast'

const userStore = useUserStore()
const toast = useToast()

const exitImpersonation = async () => {
  // Simply signing out will end the impersonation session.
  // The super admin will then need to log back in with their own credentials.
  // The one session teardown (src/services/sessionEnd.js) closes the impersonated session's listeners before auth
  // goes away, and the home page loads fresh, so nothing of that account stays in memory.
  toast.info('Exiting impersonation mode...')
  await userStore.signOutUser({ redirectTo: '/' })
}
</script>
